export default __webpack_public_path__ + "static/media/keeprz.3fa3a958.png";